export default {
  signatureKey (state) {
    return state.value
  }
}
